module.exports = __webpack_public_path__ + "img/dart.fa9adc83.svg";